import { render, staticRenderFns } from "./3_1_historyPatients.vue?vue&type=template&id=4f281f22&scoped=true&"
import script from "./3_1_historyPatients.vue?vue&type=script&lang=js&"
export * from "./3_1_historyPatients.vue?vue&type=script&lang=js&"
import style0 from "./3_1_historyPatients.vue?vue&type=style&index=0&id=4f281f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f281f22",
  null
  
)

export default component.exports